import { Stack, Typography } from "@mui/material";
import { CampaignStatistics } from "../../types/apiTypes";

type Props = {
  total_accounts: number;
  statistics: CampaignStatistics;
};

export const ProductStatisticsBlock = ({
  statistics,
  total_accounts,
}: Props) => {
  const {
    analyzed_accounts,
    total_contacts,
    activated_contacts,
    committee_members,
    cluster_members,
  } = statistics;

  const list = [
    {
      label: "Analyzed Accounts",
      value: `${analyzed_accounts}/${total_accounts}`,
    },
    {
      label: "Activated Contacts",
      value: `${activated_contacts}/${total_contacts}`,
    },
    {
      label: "Buying Committee Members",
      value: `${committee_members || "-"}`,
    },
    {
      label: "Buying Cluster Members",
      value: `${cluster_members || "-"}`,
    },
  ];

  return (
    <Stack gap={"4px"}>
      {(total_accounts
        ? list
        : [{ label: "Analyzed Accounts", value: "0" }]
      ).map(({ label, value }) => (
        <Stack
          key={label}
          flexDirection={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography
            sx={{
              fontSize: "14px",
              lineHeight: "22px",
              color: "#797979",
            }}
          >
            {label}
          </Typography>
          <Typography
            sx={{
              fontSize: "18px",
              lineHeight: "22px",
              color: "#051123",
              fontWeight: 600,
            }}
          >
            {value}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};
